module.exports = __webpack_public_path__ + "img/winerack29.55df4ade.jpg";